import { ClaudeDesktopIcon } from './ClaudeDesktopIcon';
import { CodexIcon } from './CodexIcon';
import { GeminiCliIcon } from './GeminiCliIcon';
import ClaudeIcon from './claude.svg?react';
import CopilotIcon from './copilot.svg?react';
import CursorIcon from './cursor.svg?react';
import DevinIcon from './devin.svg?react';
import LogoWithoutText from './latest-logo-no-text.svg?react';
import LogoWithText from './latest-logo-with-text.svg?react';
import VSCodeIcon from './visual-studio.svg?react';

export const Images = {
  LogoWithText,
  LogoWithoutText,
  CursorIcon,
  VSCodeIcon,
  CopilotIcon,
  ClaudeIcon,
  ClaudeDesktopIcon,
  CodexIcon,
  GeminiCliIcon,
  DevinIcon,
} as const;
